'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = {
  xxl: 1600,
  xl: 1280,
  l: 960,
  m: 600,
  s: 320,
  currentBreakpoint: function currentBreakpoint() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var targets = points.length ? points : 'xxl,xl,l,m,s'.split(',');
    var _window = window,
        innerWidth = _window.innerWidth;
    var breakpoint = targets.reduce(function (ret, point) {
      if (innerWidth < breakpoints[ret]) {
        return point;
      }

      return ret;
    }, targets[0]);
    return breakpoint;
  }
}; // helpers to target a size or smaller styles

var minWidths = exports.minWidths = {
  s: '@media (min-width: ' + breakpoints.m + 'px)',
  m: '@media (min-width: ' + breakpoints.l + 'px)',
  l: '@media (min-width: ' + breakpoints.xl + 'px)',
  xl: '@media (min-width: ' + breakpoints.xxl + 'px)'
}; // prefer min width > max width

var breakSize = exports.breakSize = {
  s: '@media (max-width: ' + breakpoints.m + 'px)',
  m: '@media (max-width: ' + breakpoints.l + 'px)',
  l: '@media (max-width: ' + breakpoints.xl + 'px)',
  xl: '@media (max-width: ' + breakpoints.xxl + 'px)'
};
var maxWidths = exports.maxWidths = breakSize;
exports.default = breakpoints;